import { Grid } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import {
  HeaderLeftWrapper,
  HeaderRightWrapper,
  HeaderWrapper,
  HeaderMenu,
  HeaderMenuItem,
  MenuItemText,
  HeaderBtnText,
} from "../Components/StyledComponents";
import { BsDownload, BsUpload, BsPrinter } from "react-icons/bs";
import { TfiSaveAlt } from "react-icons/tfi";
import ModalDialog from "../Components/ModalDialog";
import SaveTemplateContent from "../Components/ModalContents/SaveTemplateContent";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsEditing,
  setIsLoggedIn,
  setSharedId,
  setShareImages,
} from "../store/reducers/loginSlice";
import { RedirectURLs, URLs } from "../utils/urls";
import DownloadDesignModal from "../Components/ModalContents/DownlaodDesignModalContent";
import axios from "axios";
import {
  createThumbnailFromJSON,
  dataURLtoFile,
  saveEditor,
} from "../utils/helpers";
import { showToast } from "../store/reducers/notificationSlice";
import { shareTemplate } from "../utils/apiHelper";
import ShareModal from "../Modals/ShareModal";
import { updateSheetObjects } from "../store/reducers/availableSheets";
import { fabric } from "fabric";
import ModalWrapper from "../Modals/ModalWrapper";
import PrintModal from "../Modals/PrintModal";
import UpgradeLimit from "../Modals/UpgradeLimit";

function Header() {
  const homePage = () => {
    window.top.location.href = process.env.REACT_APP_mainDomain;
  };
  return (
    <>
      <HeaderWrapper>
        <Grid
          container
          spacing={2}
          sx={{ m: 0, height: "100%", width: "calc(100% + 0px) !important" }}
        >
          <Grid item md={3} sx={{ pt: "0px !important", height: "100%" }}>
            <HeaderLeftWrapper>
              <Box sx={{ pl: 0, cursor: "pointer" }} onClick={homePage}>
                <img src="/images/logo/atlas_logo.png" className="site-logo" />
              </Box>
            </HeaderLeftWrapper>
          </Grid>
          <Grid item md={9} sx={{ pt: "0px !important", height: "100%" }}>
            <HeaderRight />
          </Grid>
        </Grid>
      </HeaderWrapper>
    </>
  );
}

export default Header;

const HeaderRight = () => {
  const [openSaveTemplateModal, setSaveTemplateModal] = useState(false);
  const [openUpgradeModal, setUpgradeModal] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.loginSlice);
  const isAdmin = useSelector((state) => state.loginSlice).isAdmin;
  const { isEditing } = useSelector((state) => state.loginSlice);
  const { shareImages } = useSelector((state) => state.loginSlice);
  const availableSheets = useSelector((state) => state.availableSheets).sheets;
  const activeSheet = useSelector((state) => state.activeSheet).sheet;
  const { canvas } = useSelector((state) => state.canvas);
  const { shareId } = useSelector((state) => state.loginSlice);

  const [activeModal, setActiveModal] = useState(null);
  const [isAdminTemp, setIsAdminTemp] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const dispatch = useDispatch();

  const closeModal = () => {
    setActiveModal(null);
  };

  const handleNext = () => {};

  const saveUserProject = async () =>
    new Promise(async (resolve, reject) => {
      setIsSaving(true);
      let cover = [];
      const { canvasData } = await saveEditor(
        "111",
        availableSheets,
        activeSheet,
        canvas
      );
      let sheetSize = { size: availableSheets[0].size };

      let { USER_PRODUCT } = URLs;

      const formData = new FormData();

      const tmpCanvas = new fabric.StaticCanvas("temp");

      dispatch(
        updateSheetObjects({
          sheetId: activeSheet.id,
          objectList: [...canvas.getObjects()],
        })
      );
      for (let ind = 0; ind < availableSheets.length; ind++) {
        let thumbnail = await createThumbnailFromJSON(
          availableSheets[ind],
          tmpCanvas
        );
        cover.push(thumbnail);
        formData.append(`sheet_${ind}`, dataURLtoFile(thumbnail, "image.png"));
      }

      formData.append("Cover", dataURLtoFile(cover[0], "image.png"));
      formData.append("FabricJs", canvasData);
      formData.append("metadata", JSON.stringify(sheetSize));

      const token = sessionStorage.getItem("auth_token");

      if (isEditing.type === "editProject") {
        formData.append("id", isEditing.id);
        axios
          .patch(`${USER_PRODUCT}${isEditing.id}/`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            dispatch(
              showToast({
                message: "Project saved successfully",
                type: "success",
              })
            );
            let newThumbnails = response.data.metadata?.thumbnailInfo?.coverPic;
            if (newThumbnails) dispatch(setShareImages(newThumbnails));
            setIsSaving(false);
            resolve({ thumbnails: newThumbnails, id: response.data.id });
          })
          .catch((error) => {
            dispatch(
              showToast({ message: "Project could not saved!", type: "error" })
            );
            setIsSaving(false);
            reject(error);
          });
      } else {
        formData.append("Title", "untitled");

        const url = `${USER_PRODUCT}?SelfBuild=${
          isEditing.type !== "createCopy"
        }&TemplateId=${
          isEditing.type === "createCopy" ? isEditing.id : "None"
        }`;

        axios
          .post(url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            dispatch(
              showToast({
                message: "Project saved Successfully!",
                type: "success",
              })
            );
            
            CloseUpgradeModal();
            dispatch(
              setIsEditing({
                value: true,
                id: res.data.id,
                type: "editProject",
              })
            );
            let newThumbnails = res.data.metadata?.thumbnailInfo?.coverPic;
            if (newThumbnails) dispatch(setShareImages(newThumbnails));
            const newUrl = `${RedirectURLs.EDITOR_PROJECT}${res.data.id}`;
            window.parent.postMessage({ newUrl }, "*");
            resolve({ thumbnails: newThumbnails, id: res.data.id });
          })
          .catch((error) => {
            setIsSaving(false);
            reject(error);
            console.error("error--", error?.response?.data?.message);
            let message = "Error saving project";
            let type = "error";
            const CODE = error?.code;

            if (CODE === "ERR_NETWORK") {
              message = `Opps check your internet connection `;
            } else if (CODE == "ERR_BAD_REQUEST") {
              message = `Your design could not be saved. ${error?.response?.data?.message}`;
              setUpgradeModal(true)

              setActiveModal({
                modal: "upgrade",
                url: cover[0],
                serverMessage: error?.response?.data?.message,
              });
            }
            dispatch(showToast({ message: message, type: type }));
          });
      }
    });

  const CloseElementsModal = () => {
    setSaveTemplateModal(false);
  };
  const CloseUpgradeModal = () => {
    setUpgradeModal(false);
  };
  const downloadCanvas = () => {
    if (!canvas) return;
    if (isLoggedIn) {
      setActiveModal("download");
    }
  };

  const handleShare = async () => {
    await navigator.clipboard.writeText(shareUrl);
    dispatch(
      showToast({ message: "URL copied to clipboard", type: "success" })
    );
    setTimeout(() => {
      setActiveModal(null);
    }, 700);
  };

  const handleShareModal = async () => {
    setIsSaving(true);
    const { thumbnails, id } = await saveUserProject(false);
    if (thumbnails) {
      shareTemplate(thumbnails, checked, id, shareId).then(async (res) => {
        setActiveModal("share");
        setIsSaving(false);
        let url = "";
        if (!shareId) {
          dispatch(setSharedId(res.id));
          url = `${process.env.REACT_APP_mainDomain}/share/design/${res.id}`;
        } else {
          url = `${process.env.REACT_APP_mainDomain}/share/design/${shareId}`;
        }
        setShareUrl(url);
      });
    }
  };

  const handlePublicChange = async (val) => {
    setIsLoading(true);
    setChecked(!val);
    if (shareImages) {
      shareTemplate(shareImages, !val, isEditing?.id, shareId).then(
        async (res) => {
          let url = "";
          if (!shareId) {
            dispatch(setSharedId(res.id));
            url = `${process.env.REACT_APP_mainDomain}/share/design/${res.id}`;
          } else {
            url = `${process.env.REACT_APP_mainDomain}/share/design/${shareId}`;
          }
          setShareUrl(url);
          setIsLoading(false);
        }
      );
    }
  };

  const handleLogIn = () => {
    sessionStorage.setItem("auth_token", "");
    dispatch(setIsLoggedIn(false));
    window.top.location.href = `${process.env.REACT_APP_mainDomain}/logout/`;
  };

  return (
    <>
      <HeaderRightWrapper>
        <HeaderMenu>
          <HeaderMenuItem onClick={handleShareModal} className={"step-7"}>
            <BsUpload size="18px" color="white" />
            <MenuItemText>Review</MenuItemText>
          </HeaderMenuItem>
          <HeaderMenuItem
            className={"step-6"}
            onClick={() => saveUserProject(false)}
          >
            <TfiSaveAlt size="18px" color="white" />
            <MenuItemText>{isSaving ? "Saving..." : "Save"}</MenuItemText>
          </HeaderMenuItem>
          {isAdmin && (
            <HeaderMenuItem
              onClick={() => {
                setSaveTemplateModal(true);
                setIsAdminTemp(true);
              }}
            >
              <TfiSaveAlt size="18px" color="white" />
              <HeaderBtnText>Save as Template</HeaderBtnText>
            </HeaderMenuItem>
          )}
          <HeaderMenuItem>
            <BsPrinter size="18px" color="white" />
            <MenuItemText>Print</MenuItemText>
          </HeaderMenuItem>
          <HeaderMenuItem className={"step-8"} onClick={downloadCanvas}>
            <HeaderBtnText>Download</HeaderBtnText>
            <BsDownload size="18px" color="white" />
          </HeaderMenuItem>
          <HeaderMenuItem onClick={handleLogIn}>
            <HeaderBtnText>{isLoggedIn ? "Log out" : "Log in"}</HeaderBtnText>
          </HeaderMenuItem>
        </HeaderMenu>
      </HeaderRightWrapper>

      <ModalWrapper
        open={activeModal === "share"}
        closeModal={closeModal}
        content={
          <ShareModal
            shareUrl={shareUrl}
            handleShare={handleShare}
            handlePublicChange={handlePublicChange}
            checked={checked}
            isLoading={isLoading}
          />
        }
      />

      <ModalWrapper
        open={activeModal === "print"}
        closeModal={closeModal}
        content={<PrintModal shareUrl={handleNext} />}
      />
      {/*
        closing this function for a well
      /}

      {/* <ModalDialog  
        // OpenModal={openUpgradeModal}
        OpenModal={true}
        CloseModal={CloseUpgradeModal}
        title="Upgrade to Unlock More Creativity 🚀"
        size="xs"
        ModalContent={<UpgradeLimit {...activeModal} />}
        defaultScroll={false}
      /> */}
      
      <ModalDialog
        OpenModal={openSaveTemplateModal}
        CloseModal={CloseElementsModal}
        title="Save Template"
        size="xs"
        ModalContent={
          <SaveTemplateContent
            setSaveTemplateModal={setSaveTemplateModal}
            isAdmin={isAdmin}
            isAdminTemp={isAdminTemp}
          />
        }
        defaultScroll={false}
      />

      <ModalWrapper
        open={activeModal === "download"}
        closeModal={closeModal}
        content={<DownloadDesignModal closeModal={closeModal} />}
      />
    </>
  );
};
